import { usePage } from '@inertiajs/react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CssBaseline from '@mui/material/CssBaseline';
import Stack from '@mui/material/Stack';
import { alpha } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React from 'react';
import AppNavbar from '../components/AppNavbar';
import SideMenu from '../components/SideMenu';
import AppTheme from '../theme/AppTheme';
import {
  chartsCustomizations,
  dataGridCustomizations,
  datePickersCustomizations,
  treeViewCustomizations,
} from '../theme/customizations';

const xThemeComponents = {
  ...chartsCustomizations,
  ...dataGridCustomizations,
  ...datePickersCustomizations,
  ...treeViewCustomizations,
};

export default function DriveSyncLayout({ children }) {
  const { props } = usePage();

  const planExpired = props.current.organization.plan_expired;

  const handleRenewPlan = () => {
    window.location.href = 'mailto:support@drivesync.com.br?subject=Renovação de plano&body=Olá, gostaria de renovar meu plano!';
  };

  return (
    <AppTheme themeComponents={xThemeComponents}>
      <CssBaseline enableColorScheme />
      <Box sx={{ display: 'flex' }}>
        <SideMenu />
        <AppNavbar />
        <Box
          component="main"
          sx={(theme) => ({
            flexGrow: 1,
            backgroundColor: theme.vars
              ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
              : alpha(theme.palette.background.default, 1),
            overflow: 'auto',
          })}
        >
          <Stack
            spacing={2}
            sx={{
              alignItems: 'center',
              mx: 3,
              pb: 5,
              mt: { xs: 8, md: 0 },
            }}
          >
            {
              planExpired ? (
                <Stack
                  direction="row"
                  sx={{
                    display: { xs: 'none', md: 'flex' },
                    width: '100%',
                    alignItems: { xs: 'flex-start', md: 'center' },
                    justifyContent: 'space-between',
                    maxWidth: { sm: '100%', md: '1700px' },
                    pt: 1.5,
                  }}
                  spacing={2}
                >
                  <Card sx={{ width: '100%' }}>
                    <CardContent>
                      <Typography variant="h4" component="h1">
                        Plano expirado
                      </Typography>
                      <Typography variant="body1" component="p" sx={{ mb: 2 }}>
                        Seu plano expirou. Por favor, entre em contato com o suporte para renovar.
                        Seus dados continuarão disponíveis até a renovação do plano.
                      </Typography>
                      <Button variant="contained" color="primary" onClick={handleRenewPlan}>
                        Renovar plano
                      </Button>
                    </CardContent>
                  </Card>
                </Stack>
              ) : (
                children
              )
            }
          </Stack>
        </Box>
      </Box>
    </AppTheme>
  );
} 